import * as React from 'react';
import S from './VideoComponent.styles';
const VideoComponent = ({ id, url, width, height, }) => {
    if (!url) {
        return null;
    }
    return (React.createElement(S.Iframe, { id: id, loading: "lazy", src: url, width: width, height: height, title: "YouTube video player", referrerPolicy: "no-referrer", allowFullScreen: true, "$maxWidth": width }));
};
export default VideoComponent;
